import(/* webpackMode: "eager" */ "/vercel/path0/apps/lms/src/app/certificate/page.tsx");
